import SliderV3 from './SliderV3';

export default SliderV3;
